import { render, staticRenderFns } from "./RebateRegras.vue?vue&type=template&id=94db3ac6&scoped=true&"
import script from "./RebateRegras.vue?vue&type=script&lang=js&"
export * from "./RebateRegras.vue?vue&type=script&lang=js&"
import style0 from "./RebateRegras.vue?vue&type=style&index=0&id=94db3ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94db3ac6",
  null
  
)

export default component.exports